import { Request, BaseApiUrl } from "./api";

// 列表
export const getMatCheckListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatCheck/Get`, { params: params });
};

//新增
export const addMatCheck = (params) => {
  return Request.post(`${BaseApiUrl}/api/MatCheck/Post`, params);
};

//删除
export const removeMatCheck = (params) => {
  return Request.post(`${BaseApiUrl}/api/MatCheck/Delete`, params);
};

//获取详情
export const getMatCheckDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatCheck/Detail`, { params: params });
};
//基础信息
export const getMatCheckBaseData = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatCheck/GetMatCheckBaseData` );
};
